import { useEffect, useState } from 'react'
import { Row, Col, Table, InputGroup, Input, InputGroupAddon, InputGroupText, Button } from 'reactstrap';
import moment from 'moment';
import BranchModal from './BranchModal';

export default function Branches({ branches, loadBranches, setActivePath }) {
    const [allBranches, setAllBranches] = useState(branches)
    const [filters, setFilters] = useState({ status: "" })
    const [modalOpen, setModalOpen] = useState(false);
    const [modalBranch, setModalBranch] = useState(null);


    useEffect(() => {
        let filteredBranches = branches;
        if (filters.status) filteredBranches = filteredBranches.filter(branch => branch.status === filters.status);
        setAllBranches(filteredBranches)
    }, [filters, branches])

    useEffect(() => {
        setActivePath("Branches")
    }, [])

    return (
        <Row className="no-gutters p-5">
            <Col>
                <Row className="vms-filters-wrapper no-gutters">
                    <Col xs={{ size: 3 }}>
                        <Button onClick={() => { setModalBranch(null); setModalOpen(true); }}> <i className="fa fa-plus" aria-hidden="true" />&nbsp;&nbsp;Add New</Button>
                    </Col>
                    <Col xs={{ size: 3, offset: 6 }}>
                        <InputGroup>
                            <Input type="select" value={filters.status} onChange={(e) => setFilters({ ...filters, status: e.target.value })}>
                                <option value="">-- Filter by Status --</option>
                                {["active", "inactive"]?.map(item => <option value={item}>{item}</option>)}
                            </Input>
                            <InputGroupAddon addonType="append">
                                <InputGroupText><i className="fa fa-search" aria-hidden="true"></i></InputGroupText>
                            </InputGroupAddon>
                        </InputGroup>
                    </Col>
                </Row>
                <Row className="no-gutters">
                    <Col className="vms-table-wrapper">
                        <Table responsive className="vms-table vms-table-queue">
                            <thead>
                                <tr>
                                    <th>Date Added</th>
                                    <th>Parent</th>
                                    <th>Name</th>
                                    <th>Custom Id</th>
                                    <th>Is Active</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {allBranches?.map(queue => <tr className="text-capitalize">
                                    <td>{queue.dateAdded ? moment(queue.dateAdded.toDate()).format('lll') : "--"} </td>
                                    <td>{queue.tenant} </td>
                                    <td><i className="fa fa-circle" aria-hidden="true" style={{ color: queue.status === "active" ? "green" : "red" }} />&nbsp;&nbsp;{queue.name}</td>
                                    <td>{queue.customId} </td>
                                    <td>{queue.status} </td>
                                    <td style={{ cursor: "pointer" }}>
                                        <i class="fa fa-pencil-square-o" aria-hidden="true" onClick={() => { setModalBranch({ ...queue, id: queue.firebaseId }); setModalOpen(true); }}></i>
                                    </td>
                                </tr>)}
                                {allBranches?.length === 0 && <tr><td colSpan={11}>No Branch Found!</td></tr>}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
                <Row className="no-gutters pt-5">
                    <Col xs={12}>
                        <i className="fa fa-circle" aria-hidden="true" style={{ color: "red" }} /> <b>&nbsp;&nbsp;Inactive</b>
                    </Col>
                    <Col xs={12}>
                        <i className="fa fa-circle" aria-hidden="true" style={{ color: "green" }} /> <b>&nbsp;&nbsp;Active</b>
                    </Col>
                </Row>
                <BranchModal
                    open={modalOpen}
                    onClose={() => { setModalOpen(false); setModalBranch(null); }}
                    branch={modalBranch}
                    branches={branches}
                    loadBranches={loadBranches}
                />
            </Col>
        </Row>
    )
}
